/** Returns the Mercury base URL for document links, stripping any trailing slash. */
export function getSiriusBaseUrl(): string {
  const url =
    (window as any).SIRIUS_URL ||
    (window as any).RCG_SIRIUS_URL ||
    window.location.origin;
  return url.replace(/\/+$/, "");
}

export const PARSE_PAGES = 2;
export const FIRM_BUSINESS_OBJECT_ENUM = 2;
export const INVESTMENT_BUSINESS_OBJECT_ENUM = 1;
export const COMPANY_BUSINESS_OBJECT_ENUM = 3;
export const DEAL_BUSINESS_OBJECT_ENUM = 4;
export const FIRM_ENGAGEMENT_BUSINESS_OBJECT_ENUM = 5;

export const PERIODIC_DOC_CATEGORY = 1;
export const DILIGENCE_DOC_CATEGORY = 2;
export const CLIENT_DOC_CATEGORY = 4;

export const CLIENT_ACCESS_LEVEL = 4;
export const ORGANIZATION_ACCESS_LEVEL = 2; // Organization access level

export const CLIENT_DOC_CATEGORIES = [CLIENT_DOC_CATEGORY];
export const NON_CLIENT_DOC_CATEGORIES = [
  PERIODIC_DOC_CATEGORY,
  DILIGENCE_DOC_CATEGORY,
];

/** Document type IDs that trigger automated extraction processing. */
export const AI_PROCESSED_DOC_TYPE_IDS = [11, 135, 15];
